const initState={
    products: [
        {
            id: 1,
            name:'Jeans',
            image:'je.jpg',
            price: 20,
            discount: 2,
            discountPrice: 20-2 /100 *20,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 2,
            name:'Kurti',
            image:'kurti.jpg',
            price: 30,
            discount: 5,
            discountPrice: 30-5 /100 *30,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 3,
            name:'aLineFrock',
            image:'aLineFrok.jpeg',
            price: 60,discount: 9,
            discountPrice: 60-9 /100 *60,
            quantity:3, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 4,
            name:'shoes',
            image:'sh.jpg',
            price: 15,
            discount: 3,
            discountPrice: 15-3 /100 *15,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 5,
            name:'RedDress',
            image:'redDress.jpg',
            price: 50,
            discount: 10,
            discountPrice: 50-10 /100 *50,
            quantity:5, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 6,
            name:'Jeans',
            image:'j.jpg',
            price: 20,
            discount: 2,
            discountPrice: 20-2 /100 *20,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 7,
            name:'Fashion Shoes',
            image:'sho.jpg',
            price: 15,
            discount: 3,
            discountPrice: 15-3 /100 *15,
            quantity:2, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 8,
            name:'Party Dress',
            image:'partyDress.jpg',
            price: 70,
            discount: 15,
            discountPrice: 70-15 /100 *70,
            quantity:3, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 9,
            name:'High Slit Latest Design',
            image:'highSlit.jpg',
            price: 40,
            discount: 6,
            discountPrice: 40-6 /100 *40,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        },
        {
            id: 10,
            name:'Short Frock',
            image:'shortFrock.jpeg',
            price: 30,
            discount: 5,
            discountPrice: 30-5 /100 *30,
            quantity:1, 
            dec:"Find Audio To Text Free Online safe and secure! Simple in use. Discover us now! Multiple sources combined. Fast and trusted. Easy Acces To Information. All the Answers. Types Information, Combined Web Results"
        }
    ],
    product : {}
}
const ProductReducer=(state = initState,action)=>{
        switch(action.type){
            case "PRODUCT":
            return {...state , product : state.products.find(product=>product.id ===
                parseInt (action.id))}
            default:
            return state;
        }
}
export default ProductReducer;